// @flow
import React from 'react';

import type { GQLProps, CMSProps } from 'Client/cms/toolkit/instagram/instagram.resolver';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Instagram } from 'Components/widgets/instagram/Instagram';
import { addTranslationKeys } from 'Src/i18n';

export type LineProps = {
  ...$Exact<CMSProps>,
  ...$Exact<GQLProps>,
};

export const InstagramLine = ({ config, id, products, title }: LineProps) => {
  if (!products || products.length === 0) {
    return null;
  }
  addTranslationKeys(config);

  const cards = products
    .filter(({ socialPictures }) => socialPictures.length > 0)
    .map(({ socialPictures, ...rest }) => {
      return {
        ...rest,
        socialPicture: socialPictures[0],
      };
    });
  return cards.length > 0 ? (
    <SiteContainer className="Line" id={id}>
      <Instagram cards={cards} title={title} />
    </SiteContainer>
  ) : null;
};
